import React from 'react';

import Button from '../../../components/ui/Button';

const UndoRedoControls = ({ canUndo, canRedo, onUndo, onRedo }) => {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        iconName="Undo"
        onClick={onUndo}
        disabled={!canUndo}
        aria-label="Отменить"
      />
      <Button
        variant="outline"
        size="sm"
        iconName="Redo"
        onClick={onRedo}
        disabled={!canRedo}
        aria-label="Повторить"
      />
    </div>
  );
};

export default UndoRedoControls;